import React from 'react';

import { IndicatorProps } from '../../types/indicator';
import { primaryRiskColorScale } from '../../styles/risk';
import { Circle } from '../../atoms/graphs';

class ScoreIndicator extends React.Component<IndicatorProps, any> {
  render() {
    const {
      className,
      innerRadius,
      outerRadius,
      radius,
      risk,
      score,
      size,
    } = this.props;

    const SIZE_MAP = {
      xs: 30,
      sm: 40,
      md: 50,
      lg: 60,
      xl: 70,
    };

    const hasCustomRadius = innerRadius && outerRadius;
    const circleProps = {
      color: primaryRiskColorScale(risk),
      startAngle: 0,
      endAngle: 360,
      strokeWidth: 0,
      score,
      ...(!hasCustomRadius && { radius: radius || SIZE_MAP[size] }),
      ...(hasCustomRadius && { innerRadius, outerRadius }),
    };

    return (
      <div className={className}>
        <Circle {...circleProps} />
      </div>
    );
  }
}

export default ScoreIndicator;
